import { useTabPaneInfo } from './TabPaneContext';

/**
 * Whether the CALLING pane is the currently-visible tab (plan §3.6). Used by
 * LopCrudPage to pause its auto-refresh interval while hidden and refresh
 * once on reactivation. Returns `true` outside a tab pane too — a screen not
 * hosted by any TabHost is trivially "active"/visible, so callers never need
 * to special-case a missing TabPaneContext.
 */
export function useTabActive(): boolean {
  const pane = useTabPaneInfo();
  return pane ? pane.isActive : true;
}
